(function () {
    'use strict';

    angular
        .module('wizard-future7.directives')
        .directive('banner', Banner)

    /** @ngInject */
    function Banner(PATHS) {
        function BannerController() {
            const vm = this;

        }

        return {
            bindToController: true,
            controller: BannerController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/banner/banner.html`,
            scope: {}
        }
    }
}());